/** Input numérico compacto com rótulo, usado nos formulários da Precificação. */
export default function CampoNumero({ label, valor, onChange, passo = 'any', minimo, desabilitado = false, destaque = false, titulo }) {
  return (
    <label className="block" title={titulo}>
      <span className="block text-[11px] font-medium text-gray-500 mb-0.5 truncate">{label}</span>
      <input
        type="number"
        step={passo}
        min={minimo}
        value={valor ?? ''}
        disabled={desabilitado}
        onChange={e => onChange(e.target.value)}
        className={`w-full px-2 py-1 text-sm border rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500 disabled:bg-gray-100 disabled:text-gray-500 ${destaque ? 'border-blue-400 bg-blue-50' : 'border-gray-300'}`}
      />
    </label>
  );
}
